import { BellIcon } from '../icons';
import { Badge } from '../Badge';
import { Button } from '../Button';
import { compteBadge, libelleCloche } from '../agents/agentsModel.js';
import { useCentre } from './useNotifications.js';
import './Notifications.css';

/**
 * Cloche de l'en-tête (P1, contrat §11.1) : ouvre le centre de notifications, nombre de
 * non-lues en pastille. Calquée sur le bouton du panier de rapport : nom accessible complet
 * (« Notifications : 3 non lues »), pastille masquée aux lecteurs d'écran, aria-expanded.
 * Absente sans contexte complet (hors de la plateforme : aucune notification à lire).
 * Sous 480 px, seule de l'en-tête : son tiroir porte aussi l'onglet « Agents ».
 */
export function NotificationsBell() {
  const { actif, nonLues, tiroir, ouvrir } = useCentre();
  if (!actif) return null;
  const label = libelleCloche(nonLues);
  return (
    <Button
      iconOnly
      icon={BellIcon}
      iconSize={18}
      className={`header-icon-button notifications-bell ${nonLues ? 'has-unread' : ''}`}
      data-centre="cloche"
      aria-haspopup="dialog"
      aria-expanded={tiroir === 'notifications'}
      aria-label={label}
      title={label}
      onClick={(event) => ouvrir('notifications', event.currentTarget)}
    >
      {nonLues > 0 && <Badge count={compteBadge(nonLues)} className="notifications-bell__count" aria-hidden="true" />}
    </Button>
  );
}
